'use client';

import { useCountdown } from '@/hooks/useCountdown';

import { splitToTimeComponents } from '@/components/atoms/countdown/utils';

import { CountdownTimer } from './Timer';

interface OfferCountdownStatusProps {
  expiry: string | null;
  classNames?: {
    root?: string;
    text?: string;
  };
}

export const OfferCountdownStatus = ({
  expiry,
  classNames,
}: OfferCountdownStatusProps) => {
  const currentMs = Date.now();
  const expiryMs = expiry ? new Date(expiry).getTime() : NaN;
  const remainingMs = Number.isFinite(expiryMs) ? expiryMs - currentMs : 0;

  const duration = useCountdown({
    time: remainingMs,
    rateOfChange: 1000,
  });

  if (!Number.isFinite(expiryMs)) return null;
  if (expiryMs <= currentMs) return null;
  if (duration <= 0) return null;

  const splitTime = splitToTimeComponents(duration);

  return (
    <CountdownTimer
      timeComponents={splitTime}
      classNames={{
        root: classNames?.root,
        text: classNames?.text,
      }}
    />
  );
};
